// Vendor
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
// Components
import { ChartCorrelationSelectorModalComponent } from './chart-correlation-selector-modal.component';
import { CorrelationSecuritySelectorComponent } from './correlation-security-selector/correlation-security-selector.component';
import { CorrelationTypeTabsComponent } from './correlation-type-tabs/correlation-type-tabs.component';
// Modules
import { AutocompleteInPlaceModule } from 'SearchApp/ts/features/autocomplete-in-place/autocomplete-in-place.module';
import { BaseAutocompleteModule } from 'SearchApp/ts/features/base-autocomplete/base-autocomplete.module';
import { IconSearchAutocompleteModule } from 'SearchApp/ts/features/icon-search-autocomplete/icon-search-autocomplete.module';
import { MetricSelectorModalModule } from 'CalculationsApp/ts/features/metric-selector-modal/metric-selector-modal.module';
import { ModalBaseModule } from 'NewAngular/features/components/modals/modal-base/modal-base.module';
import { SimpleDropdownModule } from 'NewAngular/features/components/dropdowns/simple-dropdown/simple-dropdown.module';
import { SimpleInputModule } from 'NewAngular/features/components/inputs/simple-input/simple-input.module';
// Pipes
import { IndexOfPipeModule } from 'NewAngular/features/pipes/index-of/index-of-pipe.module';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "@angular/forms";
import * as i3 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-footer.component";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
export class ChartCorrelationSelectorModalModule {
}
ChartCorrelationSelectorModalModule.ɵfac = function ChartCorrelationSelectorModalModule_Factory(t) { return new (t || ChartCorrelationSelectorModalModule)(); };
ChartCorrelationSelectorModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ChartCorrelationSelectorModalModule });
ChartCorrelationSelectorModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [AutocompleteInPlaceModule,
        BaseAutocompleteModule,
        CommonModule,
        FormsModule,
        IconSearchAutocompleteModule,
        IndexOfPipeModule,
        MetricSelectorModalModule,
        ModalBaseModule,
        SimpleDropdownModule,
        SimpleInputModule] });
i0.ɵɵsetComponentScope(ChartCorrelationSelectorModalComponent, [i1.NgIf, i2.DefaultValueAccessor, i2.NumberValueAccessor, i2.NgControlStatus, i2.MinValidator, i2.MaxValidator, i2.NgModel, i3.ModalBaseComponent, i4.SimpleModalFooterComponent, i5.SimpleModalHeaderComponent, CorrelationTypeTabsComponent,
    CorrelationSecuritySelectorComponent], []);
